export const WorkData = [
    {
        company: "Luday AB Software" ,
        designation: "Full Stack Developer",
        dateJoining: "3/2022",
        dateEnd: "To date",
        companyLogo:"https://cdn-icons-png.flaticon.com/512/2537/2537338.png",
        work:"I Improved the efficiency of all enterprise software by more than 95% with revisions and workflow changes on comdoity.com, Created Rest API using python for a backend application, Worked in a team to recreate https://beatdealnaija.com to an e-commerce website using react and python, Configured the VPS Server with apache and passenger to serve the bestdealnaija website",
    },
    {
        company: "ABC Capital Limited" ,
        designation: "IT Expert",
        dateJoining: "10/2021",
        dateEnd: "2/2022",
        companyLogo:"https://cdn-icons-png.flaticon.com/512/2537/2537415.png",
        work:"I developed, tested and implemented programs to ensure stability and dependability of the company’s web application, Connected computers to the network and trouble shoot software issues, Played a key role in the development, improvement, and operation of web-based software for taxi service, Grew the companys visibility online by rebranding some aspect of the companies digital assest and digital marketing"
    },
    {
        company: "EbonyTech ICT SERVICES" ,
        designation: "Full Stack Developer",
        dateJoining: "9/2016",
        dateEnd: "8/2019",
        companyLogo:"https://cdn-icons-png.flaticon.com/512/2537/2537415.png",
        work:"I improved the efficiency of all enterprise software by more than 60% with revisions and workflow changes, created end to end web applications for schools, companys and Individuals, interfaced with client of the company to understand their needs and prepare workflow"
    },
    {
        company: "Ebarcs Microfinance Bank Ltd" ,
        designation: "IT Staff (Internship)",
        dateJoining: "4/2015",
        dateEnd: "1/2016",
        companyLogo:"https://cdn-icons-png.flaticon.com/512/2537/2537415.png",
        work:"I worked directly with other IT staffs to achieve full restoration of data from a backup while configuring a new server when the old one crashed, Supported the IT manager, configured and maintained various hardware and software, and performed regular back-ups. Installed computer systems and executed other duties as required"
    }
    
]